// config
import * as http from 'utils/http';
import config from 'config';

const rejectQuote = async ({ ticketId, quoteId, feedBackDTO }) => {
  return http.post(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/${quoteId}/rejections/`,
    {
      feedback: { ...feedBackDTO, stars: 0 },
    }
  );
};

export default rejectQuote;
